<div class="subheader with-padding flgrow">
    <div class="row align-items-center">
        <div class="col-6 col-lg-3">
            <div class="relative flmid">
                <div class="input-group flgrow">
                    <input class="form-control" type="text" name="searchTerm"
                        placeholder="{{ 'lblSearch' | translate }}" [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onSearchFilter()"/>
                    <div class="input-group-append">
                        <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                            <em class="fa fa-search"></em>
                        </button>
                    </div>
                </div>
            </div>

        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
            <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
                (change)="StatusChange($event)">
                <ng-option *ngFor="let status of StatusList" [value]="status.id">
                    {{status.value}}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="isDmsSyncPackage">
            <ng-select placeholder="{{ 'lblDMSStatus' | translate }}" [(ngModel)]="selectedSync"
                (change)="SyncChange($event)">
                <ng-option *ngFor="let status of SyncList" [value]="status.id">
                    {{status.value}}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="isDmsSyncPackage">
            <ng-select placeholder="{{ 'lblSource' | translate }}" [(ngModel)]="sourceName"
                (change)="SourceChange($event)">
                <ng-option *ngFor="let source of applicationSourceList" [value]="source.sourceId">
                    {{source.sourceName}}
                </ng-option>
            </ng-select>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 pl-4" *ngIf="isShowDealerDropdown && dealerList && dealerList.length > 0">
            <div class="relative flmid">
              <div class="flgrow">
                <app-dealer-searchbox-dropdown [dealerList]="dealerList" [selectedDealer]="selectedDealerId" ngDefaultControl
                  name="dealerDropdown" (onSelectDealer)="onDealerSelected($event)" placeholder="Search Dealer" [disabled]="dealerList.length === 1">
                </app-dealer-searchbox-dropdown>
              </div>
            </div>
          </div>
        <div class="col-auto ml-auto" >
            <a  class="ml-2 btn btn-outline-primary mr-2" href="javascript:void(0);" (click)="onRefresh()"
            aria-label="Center Align">
            <em class="fas fa-sync fa-lg"></em>
            </a>
            <button type="button" (click)="onAdd()" *ngIf="userRoleRightsDetails.canAdd" aria-label="Center Align" type="reset"
                class="add-button btn btn-primary" translate>lblAddPackage</button>
        </div>
    </div>
</div>
<div class="prel container">
    <div class="row">
        <div class="c12">
            <div class="card mb-3 scrollbar " [ngClass]="''">
                <div class="card-header d-flex justify-content-between" translate>
                    lblPackages
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                        totalCount
                        }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>
                <div class="table-responsive max-h254" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                    [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                    <table class="tablest1 table-hover">
                        <thead>
                            <tr>
                                <th style="width:40px" scope="col"> </th>
                                <th style="width:55px" scope="col">#</th>
                                <th scope="col" sortable="packageNumber" (sort)="onSort($event)" translate>
                                    lblPackageNumber
                                </th>
                                <th scope="col" translate>lblPackageName</th>
                                <th scope="col" translate>lblMakeCode</th>
                                <th scope="col" class="text-center" translate *ngIf="isDmsSyncPackage">lblSource</th>
                                <th scope="col" style="width:50px" sortable="updatedDate"
                                    (sort)="onSort($event)" translate>lblUpdatedDate</th>
                                <th scope="col" style="width:50px" sortable="dmsSyncDate"
                                    (sort)="onSort($event)" translate *ngIf="isDmsSyncPackage">lbllastSyncdate</th>
                                <th class="text-center" scope="col" translate>lblActive</th>    
                                <th style="width:120px" scope="col" translate class="text-center">lblAction
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="packagesList?.length>0; else load_else">
                                <ng-container *ngFor="let check of packagesList; let i=index" class="mb-3">
                                    <tr [ngClass]="{'bg-info': check.expanded}">
                                        <td style="width:40px" (click)="check.expanded = !check.expanded">
                                            <a class="btn btn-ico" ngbTooltip="Show Package"
                                                (click)="getPackageVersion(check.id,i)"
                                                tooltipClass="custom-revert">
                                                <em class="fas fa-chevron-right fa-lg"
                                                    [ngClass]="{'fa-chevron-up': check.expanded}"></em>
                                            </a>
                                        </td>
                                        <td>{{ check.rowNumber }}</td>

                                        <td style="width:25%">
                                            <ngb-highlight [result]="check.packageNumber">
                                            </ngb-highlight>
                                        </td>
                                        <td>
                                            <ngb-highlight [result]="check.name">
                                            </ngb-highlight>
                                        </td>
                                        <td>
                                            <ngb-highlight [result]="check.makeCode">
                                            </ngb-highlight>
                                        </td>
                                        <td *ngIf="isDmsSyncPackage">
                                            <ngb-highlight
                                                [ngClass]="check.sourceType ? 'flmid sourceBox rounded-0 justify-content-center' : ''"
                                                [result]="check.sourceType">
                                            </ngb-highlight>
                                        </td>
                                        <td>
                                            {{ check.updatedDate | date:'short'}}
                                        </td>
                                        <td *ngIf="isDmsSyncPackage" >
                                            {{ check.dmsSyncDate | date:'short'}}
                                        </td>
                                        <td class="text-center">
                                            <em class="fas fa-check" *ngIf="check.isActive == true"></em>
                                            <em class="fas fa-close" *ngIf="check.isActive == false"></em>
                                        </td>
                                        <td class="nowrap text-right">
                                            <ng-container *ngIf="showDmsLinkButton(check.sourceTypeId)">
                                                <a class="btn btn-ico"
                                                    ngbTooltip="{{ 'lblSyncToDMS' | translate }}"
                                                    tooltipClass="custom-revert"
                                                    [class.invisible]="check.dmsSyncStatus != 0"
                                                    (click)="onSyncToDms(check.id)">
                                                    <em class="fas fa-sync fa-lg  "></em>
                                                </a>
                                                <span class="ico-div"
                                                    [class.invisible]="check.dmsSyncStatus != 0"></span>
                                                <a class="btn btn-ico"
                                                    ngbTooltip="{{ 'lblDMSSyncFailedlog' | translate }}"
                                                    tooltipClass="custom-revert"
                                                    [class.invisible]="check.dmsSyncStatus != 0"
                                                    (click)="viewException(check.id)">
                                                    <em class="fas fa-clipboard-list fa-lg  "></em>
                                                </a>
                                                <span class="ico-div"
                                                    [class.invisible]="check.dmsSyncStatus != 0"></span>
                                            </ng-container>
                                            
                                            <a class="btn btn-ico" ngbTooltip="{{'lblCopyPackage' | translate}}" tooltipClass="custom-revert"
                                                *ngIf="showCopyLinkButton(check.sourceTypeId)"
                                                (click)="copyPackagePopUp(mymodal,check)">
                                                <em class="fas fa-copy fa-lg"></em>
                                            </a>
                                            <span class="ico-div" *ngIf="userRoleRightsDetails.canEdit"></span>
                                            <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                                                *ngIf="userRoleRightsDetails.canEdit"
                                                (click)="editPackagePopUp(check.packageNumber,check.id,check.sourceTypeId)">
                                                <em class="fas fa-pencil-alt fa-lg"></em>
                                            </a>
                                            <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                                            <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                                (click)="deletePackageV1(check.id)"
                                                *ngIf="userRoleRightsDetails.canDelete">
                                                <em class="far fa-trash-alt fa-lg"></em>
                                            </a>


                                        </td>

                                    </tr>
                                    <ng-container *ngIf="check.expanded">
                                        <tr class="table-active">
                                            <td colspan="9" class="p-2 pl47">

                                                <table class="tablest1 border bg-virsion">

                                                    <thead>
                                                        <tr>
                                                            <th style="width:40px"></th>
                                                            <th style="width:26%" translate>lblVersionNumber</th>
                                                            <th translate>lblVersionName</th>
                                                            <th translate>lblNoOfItem</th>
                                                            <th translate>lblSalesPrice</th>
                                                            <th style="width:120px" scope="col" translate
                                                                class="text-center">
                                                                <a class="btn btn-ico" ngbTooltip="{{'lblAddVersion' | translate}}"
                                                                    tooltipClass="custom-revert"
                                                                    *ngIf="userRoleRightsDetails.canAdd"
                                                                    (click)="editPackagePopUp(check.packageNumber,check.id,check.sourceTypeId)">
                                                                    <em class="fas fa-plus fa-lg"></em>
                                                                </a>
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <ng-container
                                                            *ngIf="check.packageVersionList?.length>0; else load_else">
                                                            <ng-container
                                                                *ngFor="let version of check.packageVersionList; let v=index"
                                                                class="mb-3">
                                                                <tr
                                                                    [ngClass]="{'bg-virsion-select': version.expandedVersion}">
                                                                    <td
                                                                        (click)="version.expandedVersion = !version.expandedVersion">
                                                                        <a class="btn btn-ico" ngbTooltip="Show Version"
                                                                            tooltipClass="custom-revert"
                                                                            (click)="getPackageBOM(version.packageId,version.id,v,i)">
                                                                            <em class="fas fa-chevron-right fa-lg"
                                                                                [ngClass]="{'fa-chevron-up': version.expandedVersion}"></em>
                                                                        </a>
                                                                    </td>
                                                                    <td>
                                                                        {{version.packageVersionNumber}}
                                                                    </td>
                                                                    <td>
                                                                        {{version.name}}
                                                                    </td>
                                                                    <td>
                                                                        {{version.noOfLine}}
                                                                    </td>
                                                                    <td>
                                                                        {{version.salesPriceAmount | number:'1.2-2'}}
                                                                    </td>
                                                                    <td class="nowrap text-center">

                                                                    </td>
                                                                </tr>

                                                                <ng-container *ngIf="version.expandedVersion">
                                                                    <tr>
                                                                        <td colspan="5" class="p-2 pl47">
                                                                            <table class="tablest1 border">
                                                                                <tr>

                                                                                    <th style="width:27%" scope="col"
                                                                                        translate>lblType</th>
                                                                                    <th style="width:21%" scope="col"
                                                                                        translate>lblNumber</th>
                                                                                    <th scope="col" translate>lblName
                                                                                    </th>
                                                                                    <th scope="col" translate>
                                                                                        lblCostType</th>
                                                                                    <th style="width:15%" scope="col"
                                                                                        translate>lblQty<span>/</span>
                                                                                        <span
                                                                                            translate>lblDuration</span>
                                                                                        (Hrs)
                                                                                    </th>
                                                                                    <th style="width:120px"
                                                                                        class="text-right" scope="col"
                                                                                        translate>lblPrice</th>
                                                                                    <th style="width:120px"
                                                                                        class="text-right" scope="col"
                                                                                        translate>lblSalesPrice</th>   
                                                                                </tr>
                                                                                <ng-container
                                                                                    *ngIf="version.packageBOMList?.length>0; else load_else">
                                                                                    <tr *ngFor="let item of version.packageBOMList; let in=index"
                                                                                        class="checkListItems">
                                                                                        <td>{{item.typeName}}</td>
                                                                                        <td>{{item.no}}</td>
                                                                                        <td>{{item.description}}</td>
                                                                                        <td>{{item.costType}}</td>
                                                                                        <td>{{item.quantity |
                                                                                            number:'1.2-2'}}</td>
                                                                                        <td class="text-right">
                                                                                            {{item.price |
                                                                                            number:'1.2-2'}}</td>
                                                                                        <td class="text-right">
                                                                                            {{item.salesPriceAmount |
                                                                                            number:'1.2-2'}}</td>
                                                                                    </tr>
                                                                                </ng-container>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                </ng-container>
                                                            </ng-container>
                                                        </ng-container>
                                                    </tbody>

                                                </table>
                                            </td>
                                        </tr>

                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</div>
<ng-template #mymodal let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title" translate>lblCreateDuplicatePackage</h4>
      <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
        (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">×</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="card pad15">
        <label class="modal-desc pb-4 text-break" translate>lblCreateDuplicatePackageConfirm</label>
        <div class="row">
            <div class="col-6">
                <label translate>lblPackageNumber</label>
                <div class="lbl-info">{{copiedPackage.packageNumber}}</div>
            </div>
            <div class="col-6">
                <label translate>lblMakeCode</label>
                <div class="lbl-info">{{copiedPackage.makeCode}}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <label for="service" translate>lblNewPackageNumber <strong class="mlt6 required">*</strong></label>
                <div class='lbl-info'>
                    <input class="form-control mb-2" [(ngModel)]="newPackageNo"   placeholder="{{ 'lblPackageNumber' | translate }}" maxlength="20">
                </div>
            </div>
            <div class="col-6">
                <label for="template-make" translate>lblNewMakeCode<strong class="mlt6 required">*</strong></label>
                <div class='lbl-info'>
                    <ng-select  [(ngModel)]="newMakeCode" [appendTo]="'body'"  placeholder="{{ 'lblSelectMake' | translate }}" required>
                        <ng-template ng-header-tmp>
                            <span class="mbold w-66px">Code</span>
                            <span class="mbold" translate>lblMake</span>
                        </ng-template>

                        <ng-option *ngFor="let type of makeList" [value]="type.brandCode">
                            <span class="w-66px">{{type.brandCode}}</span>
                            <span class="mx-2 hide-ng-dropdown-panel">-</span>
                            <span>{{type.brandName}}</span>
                        </ng-option>
                    </ng-select>
                </div>
            </div>
            <div class="col-4">
                
            </div>
        </div>
      </div>
      
    </div>
    <div class="modal-footer">
      <div class="d-flex flex-sm-row flex-column justify-content-end">
        <button type="submit" class="btn btn-primary mr-sm-2" translate (click)="createDuplicatePackage()">lblSave</button>
        <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary" aria-label="Center Align"
          translate>lblCancel</button>
      </div>
    </div>
  </ng-template>